import {
    Box,
    Flex,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import './index.css'; // Assuming this path is correct

export default function BrandAnalysisTable({ finalData }) { // Renamed from SuspectedBrandsTable to match your file name
    const textColor = useColorModeValue("gray.800", "gray.100");
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
    const headerBg = useColorModeValue("gray.50", "gray.700");
    const hoverBg = useColorModeValue("gray.100", "whiteAlpha.100");
    const tableBg = useColorModeValue("white", "gray.800");
    const badgeColors = ["#6ce5e8", "#41b8d5", "#2d8bba"];

    // UNCONDITIONALLY CALL useColorModeValue here for the total row text color
    const totalRowTextColor = useColorModeValue("gray.700", "gray.200");

    // Calculate totals for Suspicious, Reported, and Removed
    // Ensure finalData is an array before reducing, especially if it can be null/undefined initially
    const dataToProcess = finalData || []; // Provide a default empty array if finalData is null/undefined

    const totalSuspicious = dataToProcess.reduce((sum, item) => sum + (item.suspicious || 0), 0);
    const totalReported = dataToProcess.reduce((sum, item) => sum + (item.reported || 0), 0);
    const totalRemoved = dataToProcess.reduce((sum, item) => sum + (item.removed || 0), 0);

    return (
        <Box
            borderRadius="12px"
            overflow="hidden"
            border="1px solid"
            borderColor={borderColor}
            bg={tableBg}
            boxShadow="sm"
            width="150%"
            maxWidth="100%"
            alignSelf="center"
            display="inline-block"
            marginLeft={1}
        >
            <Table variant="simple" size="sm" color="black.500" mb="12px">
                <Thead bg={headerBg}>
                    <Tr>
                        <Th py="10px" fontSize="11px" color="gray.600" textAlign="center">
                            {finalData && finalData[0]?.Platforms ? 'Platform' : 'Brand'}
                        </Th>
                        {["Suspicious", "Reported", "Removed"].map((label, idx) => (
                            <Th key={idx} py="10px" textAlign="center">
                                <Flex direction="column" align="center">
                                    <Box
                                        w="100%"
                                        h="3px"
                                        bg={badgeColors[idx]}
                                        mb="4px"
                                        borderRadius="2px"
                                    />
                                    <Text fontSize="10px" fontWeight="500" color="gray.600">
                                        {label}
                                    </Text>
                                </Flex>
                            </Th>
                        ))}
                    </Tr>
                </Thead>
                <Tbody>
                    {dataToProcess.map((item, index) => (
                        <Tr key={index} _hover={{ bg: hoverBg }} >
                            <Td
                                py="14px"
                                px="12px"
                                fontSize="13px"
                                color={textColor}
                                textAlign="center"
                                fontWeight="500"
                                borderBottom="1px solid"
                                borderColor={borderColor}
                            >
                                {item.brands || item.Platforms}
                            </Td>
                            {[item.suspicious, item.reported, item.removed].map((val, i) => (
                                <Td key={i} textAlign="center" py="10px" px="12px"
                                    borderBottom="1px solid"
                                    borderColor={borderColor}>
                                    <Box
                                        as="span"
                                        bg={`${badgeColors[i]}1A`} // ~10% opacity
                                        color={badgeColors[i]}
                                        px="8px"
                                        py="3px"
                                        borderRadius="4px"
                                        fontSize="12px"
                                        fontWeight="600"
                                    >
                                        {val}
                                    </Box>
                                </Td>
                            ))}
                        </Tr>
                    ))}
                    {/* Total Row - Ensure this is always rendered, but its content might be conditional */}
                    <Tr fontWeight="bold" bg={headerBg}>
                        <Td
                            py="14px"
                            px="12px"
                            fontSize="13px"
                            color={totalRowTextColor} // Use the unconditionally called hook value
                            textAlign="center"
                            borderBottom="none"
                            textDecoration="underline"
                        >
                            Total
                        </Td>
                        {[totalSuspicious, totalReported, totalRemoved].map((totalVal, i) => (
                            <Td
                                key={`total-${i}`}
                                textAlign="center"
                                py="10px"
                                px="12px"
                                borderBottom="none"
                            >
                                <Box
                                    as="span"
                                    bg={`${badgeColors[i]}1A`}
                                    color={badgeColors[i]}
                                    px="8px"
                                    py="3px"
                                    borderRadius="4px"
                                    fontSize="13px"
                                    fontWeight="800"
                                >
                                    {totalVal}
                                </Box>
                            </Td>
                        ))}
                    </Tr>
                </Tbody>
            </Table>

            <Text fontSize="10px" color="gray.500" mt="1px" mb="5px" textAlign="center" padding='2px'>
                Note: The total numbers may not match exactly, as some previously reported
                products may have been taken down this month, and vice versa.
            </Text>
        </Box>
    );
}